import React, { useEffect, useState } from "react";
import { FaLocationDot, FaQuoteRight } from "react-icons/fa6";
import constusbanner from "../../Assests/dubai_city.webp";
import { Link } from "react-router-dom";
import vidaresidence from "../../Assests/vida-residences.webp";
import golfhillside from "../../Assests/Golf-Hillside.webp";
import greenridge from "../../Assests/greenridge-at-emaar-south.webp";
import bayzbydanube from "../../Assests/bayz-by-danube.webp";
import bayzbydanube101 from "../../Assests/bayz-101-2.jpg-1536x995.webp";
import timebydanube from "../../Assests/timez-bydanube.webp";
import { FaPhoneAlt } from "react-icons/fa";
import { IoMail } from "react-icons/io5";
import Slider from "react-slick";
import company1 from "../../Assests/nakheel.webp";
import company2 from "../../Assests/emaar.webp";
import company3 from "../../Assests/omniyat.webp";
import company4 from "../../Assests/damac.webp";
import company5 from "../../Assests/sobha.webp";
import company6 from "../../Assests/ellington.webp";
import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Pagination } from "swiper/modules";
import Aos from "aos";

const developments = [
  {
    id: 1,
    image: vidaresidence,
    title: "Vida Residences",
    location: "Dubai Marina",
  },
  {
    id: 2,
    image: golfhillside,
    title: "Golf Hillside",
    location: "Dubai Hills Estate",
  },
  {
    id: 3,
    image: greenridge,
    title: "Greenridge at Emaar South",
    location: "Dubai South",
  },
  {
    id: 4,
    image: greenridge,
    title: "BAYZ by Danube",
    location: "Business Bay Dubai",
  },
  {
    id: 5,
    image: bayzbydanube101,
    title: "BAYZ101 by Danube",
    location: "Dubai Hills Estate",
  },
  {
    id: 6,
    image: timebydanube,
    title: "TIMEZ by Danube",
    location: "Silicon Oasis Dubai",
  },
];

const DubaidevelopmentSection = () => {
  const [name, setName] = useState("");
  const [email, setEmail] = useState("");
  const [phone, setPhone] = useState("");
  const [message, setMessage] = useState("");

  const datatest = [
    {
      name: "VIKRAM SHARMA",
      text: `The team at Handa Realtor is exceptional! They introduced me to investment options in Dubai that I hadn’t considered before. Their understanding of both the Canadian and Dubai markets is unmatched. I’ve already recommended them to a few friends looking for global investment opportunities.`,
    },
    {
      name: "PRIYA PATEL",
      text: `I recently sold my home in Toronto with the help of Handa Realtor, and I couldn’t be happier with the experience! Parth and his team were incredibly professional and made the entire process stress-free. From pricing my property just right to negotiating with buyers, everything was handled with expertise. I highly recommend them to anyone looking to sell their property in Canada!`,
    },
    {
      name: "ANJALI VERMA",
      text: `As a first-time homebuyer in Canada, I was nervous about the entire process, but Handa Realtor made it so smooth and stress-free. Parth patiently answered all my questions, helped me find the perfect home within my budget, and guided me every step of the way. I’m so grateful for their expertise and support. Highly recommend them to anyone looking to buy a home!`,
    },
    {
      name: "AISHA KHAN",
      text: `Parth and his team were amazing to work with! I was initially hesitant about investing in Dubai properties, but their knowledge and professionalism put me at ease. They made the entire process seamless, and I feel confident about my decision. If you're in Canada and considering Dubai investments, Handa Realtor is the way to go.`,
    },
    {
      name: "RAJIV MEHTA",
      text: `I recently connected with Parth Handa through his Dubai investment campaign, and I’m so glad I did! He explained everything about the Dubai real estate market in a way that was easy to understand. The opportunities he presented were not only lucrative but also perfectly aligned with my investment goals. Highly recommend his expertise!`,
    },
  ];

  const handleformsubmit = async (e) => {
    e.preventDefault();
    try {
      const response = await fetch("https://handarealtor.ca/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({
          name,
          email,
          phone,
          message,
        }),
      });
      const data = await response.json();
      if (response.ok) {
        console.log("Form Submitted Successfully", data);

        setName("");
        setEmail("");
        setPhone("");
        setMessage("");
      } else {
        console.log("Submission Failed", data);
      }
    } catch (error) {
      console.log("Something Went Wrong", error);
    }
  };

  const settingstest = {
    dots: true,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 3000,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  const companySliderSettings = {
    dots: false,
    arrows: false,
    infinite: true,
    autoplay: true,
    autoplaySpeed: 2500,
    speed: 600,
    slidesToShow: 3,
    slidesToScroll: 1,
    responsive: [
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 1,
        },
      },
    ],
  };

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  useEffect(() => {
    Aos.init({
      duration: 1000,
      once: true,
    });
  }, []);
  return (
    <>
      <section
        className="contact-banner d-flex align-items-center justify-content-center text-center text-white"
        style={{
          backgroundImage: `url(${constusbanner})`,
        }}
      >
        <div className="overlay"></div>

        <div className="content w-100 container pt-5">
          <h1 className="text-start banner-title">Dubai Developments</h1>
        </div>
      </section>
      <section className="py-5" style={{ backgroundColor: "#efefef" }}>
        <div className="container">
          <h2
            className="text-center mb-5"
            data-aos="fade-zoom-in"
            data-aos-easing="ease-in-back"
            data-aos-delay="300"
            data-aos-offset="0"
          >
            Dubai Developments
          </h2>
          <div className="row g-4">
            {developments.map((item) => (
              <div
                className="col-sm-12 col-md-12 col-lg-12 col-xl-4"
                key={item.id}
              >
                <div
                  className="h-100 d-flex flex-column overflow-hidden position-relative"
                  style={{
                    backgroundColor: "#000",
                  }}
                >
                  <div
                    style={{
                      height: "420px",
                      overflow: "hidden",
                    }}
                  >
                    <img
                      src={item.image}
                      alt={item.title}
                      className="w-100 h-100"
                      style={{
                        objectFit: "cover",
                      }}
                    />
                  </div>

                  <div
                    className="position-absolute start-50 translate-middle-x"
                    style={{
                      top: "390px",
                      zIndex: 2,
                    }}
                  >
                    <Link
                      to="#"
                      className="btn text-uppercase fw-semibold"
                      data-aos="fade-zoom-in"
                      data-aos-easing="ease-in-back"
                      data-aos-delay="300"
                      data-aos-offset="0"
                      style={{
                        background: "linear-gradient(135deg, #af8e5b, #fff093)",
                        color: "#fff",
                        letterSpacing: "2px",
                        padding: "18px 35px",
                        borderRadius: "8px",
                        minWidth: "300px",
                      }}
                    >
                      EMMAAR PROPERTIES
                    </Link>
                  </div>

                  <div
                    className="text-center text-white d-flex flex-column justify-content-center"
                    style={{
                      minHeight: "160px",
                      paddingTop: "50px",
                      paddingBottom: "40px",
                    }}
                  >
                    <h4 className="">{item.title}</h4>

                    <p className="mb-0 ">
                      <FaLocationDot className="me-2" />
                      {item.location}
                    </p>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>
      <section className="py-5" style={{ backgroundColor: "#000000" }}>
        <div className="container">
          <div className="row">
            <div className="col-md-4">
              <h2 className="text-white">TRUSTED BY TOP COMPANIES</h2>
            </div>
            <div className="col-md-8 mt-3 mt-md-3">
              <Slider {...companySliderSettings}>
                <div className="px-2">
                  <div className=" border border-secondary p-2 d-flex align-items-center justify-content-center h-100">
                    <img src={company1} alt="Company" className="img-fluid" />
                  </div>
                </div>

                <div className="px-2">
                  <div className=" border border-secondary p-2 d-flex align-items-center justify-content-center h-100">
                    <img src={company2} alt="Company" className="img-fluid" />
                  </div>
                </div>

                <div className="px-2">
                  <div className=" border border-secondary p-2 d-flex align-items-center justify-content-center h-100">
                    <img src={company3} alt="Company" className="img-fluid" />
                  </div>
                </div>

                <div className="px-2">
                  <div className=" border border-secondary p-2 d-flex align-items-center justify-content-center h-100">
                    <img src={company4} alt="Company" className="img-fluid" />
                  </div>
                </div>
                <div className="px-2">
                  <div className=" border border-secondary p-2 d-flex align-items-center justify-content-center h-100">
                    <img src={company5} alt="Company" className="img-fluid" />
                  </div>
                </div>
                <div className="px-2">
                  <div className=" border border-secondary p-2 d-flex align-items-center justify-content-center h-100">
                    <img src={company6} alt="Company" className="img-fluid" />
                  </div>
                </div>
              </Slider>
            </div>
          </div>
        </div>
      </section>
      <section
        className="properties-section"
        style={{ backgroundColor: "#E9E9E9" }}
      >
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-md-12">
              <p
                className="text-center text-uppercase text-dark"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Explore Properties
              </p>
              <h2
                className="text-center text-dark mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Client Feedback
              </h2>
              <Swiper
                modules={[Autoplay]}
                spaceBetween={20}
                autoplay={{ delay: 3000, disableOnInteraction: false }}
                loop={true}
                breakpoints={{
                  0: {
                    slidesPerView: 1, // mobile → 1 card
                  },
                  768: {
                    slidesPerView: 2, // tablet → 2 cards
                  },
                  992: {
                    slidesPerView: 3, // desktop → 3 cards
                  },
                }}
              >
                {datatest.map((item, index) => (
                  <SwiperSlide key={index}>
                    <div className="card border-0 bg-light text-center h-100 p-4 rounded-3">
                      <h6 className="fw-semibold mb-3">{item.name}</h6>
                      <p className="small">"{item.text}"</p>
                      <div className="d-flex justify-content-center mt-auto">
                        <div
                          className="bg-dark text-white rounded-circle d-flex align-items-center justify-content-center"
                          style={{
                            width: "60px",
                            height: "60px",
                            fontSize: "20px",
                          }}
                        >
                          <FaQuoteRight />
                        </div>
                      </div>
                    </div>
                  </SwiperSlide>
                ))}
              </Swiper>
            </div>
          </div>
        </div>
      </section>
      <section className="properties-section">
        <div className="container">
          <div className="row justify-content-center align-items-center">
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6">
              <p
                className="text-start text-uppercase text-muted"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                CONTACT INFO
              </p>

              <h2
                className="text-start mb-4"
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Our Experts Are Ready to Work With You
              </h2>

              <p
                data-aos="fade-zoom-in"
                data-aos-easing="ease-in-back"
                data-aos-delay="300"
                data-aos-offset="0"
              >
                Get in touch with our team for trusted guidance, responsive
                communication, and local Nashville market expertise.
              </p>

              <div className="d-flex align-items-center mt-3">
                <FaPhoneAlt className="me-2 text-dark fs-3" />
                <div>
                  <h5 className="mb-0">Phone</h5>
                  <Link
                    to="tel:+16479876291"
                    className="text-decoration-none "
                    style={{ color: "#7A7A7A" }}
                  >
                    +1 (647) 987-6291
                  </Link>
                </div>
              </div>
              <div className="d-flex align-items-center mt-3">
                <IoMail className="me-2 text-dark fs-3" />
                <div>
                  <h5 className="mb-0">Email</h5>
                  <Link
                    to="mailto:handa.realtor@gmail.com"
                    className="text-decoration-none "
                    style={{ color: "#7A7A7A" }}
                  >
                    handa.realtor@gmail.com
                  </Link>
                </div>
              </div>
            </div>
            <div className="col-sm-12 col-md-12 col-lg-12 col-xl-6 mt-3 mt-md-5 d-flex justify-content-xl-end">
              <form
                className="shadow rounded-3 p-4 w-100 w-md-75"
                onSubmit={handleformsubmit}
              >
                <div className="row">
                  <div className="col-12 mb-3">
                    <input
                      type="text"
                      className="form-control rounded-3"
                      placeholder="Your Name"
                      required
                      value={name}
                      onChange={(e) => setName(e.target.value)}
                    />
                  </div>

                  <div className="col-12  mb-3">
                    <input
                      type="email"
                      className="form-control rounded-3"
                      placeholder="Email Address"
                      required
                      value={email}
                      onChange={(e) => setEmail(e.target.value)}
                    />
                  </div>

                  <div className="col-12  mb-3">
                    <input
                      type="tel"
                      className="form-control rounded-3"
                      placeholder="Phone Number"
                      value={phone}
                      onChange={(e) => setPhone(e.target.value)}
                    />
                  </div>

                  <div className="col-12 mb-3">
                    <textarea
                      className="form-control rounded-3"
                      rows="6"
                      placeholder="Your Message"
                      required
                      value={message}
                      onChange={(e) => setMessage(e.target.value)}
                    ></textarea>
                  </div>

                  <div className="col-12 text-center">
                    <button type="submit" className="btn btn-dark px-4 w-100">
                      Submit
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  );
};

export default DubaidevelopmentSection;
